import React, { useEffect, useState } from 'react';
import './BleedingControlKit.css';
import './GeneralButton.css';
import GeneralButtonWithImg from './GeneralButtonWithImg';
var disableTourniqueteButton = false;
var disablePressureDressingButton = false;
var disablePPEButton = false;
const BleedingControlKit = (obj: any) => {

	const [btnsShown, showBtns] = useState(false);

	useEffect(() => {
		if(typeof obj.parameters.disableTourniqueteButton !== 'undefined' && disableTourniqueteButton != obj.parameters.disableTourniqueteButton) {
			disableTourniqueteButton = obj.parameters.disableTourniqueteButton;
		}
		if(typeof obj.parameters.disablePressureDressingButton !== 'undefined' && disablePressureDressingButton != obj.parameters.disablePressureDressingButton) {
			disablePressureDressingButton = obj.parameters.disablePressureDressingButton;
		}
		if(typeof obj.parameters.disablePPEButton !== 'undefined' && disablePPEButton != obj.parameters.disablePPEButton) {
			disablePPEButton = obj.parameters.disablePPEButton;
		}
	}, [obj.parameters.disablePPEButton, obj.parameters.disablePressureDressingButton, obj.parameters.disableTourniqueteButton]);

	const img = {
		src: './assets/img/cross.png',
		style: {
			padding: '2%',
			width: '30%'
		}
	};

	return (
		<div className={`bleeding-control-container modal-disable-select ${obj.parameters.disabled ? 'disabled-container' : ''}`}>
			<div className="ui-inner-container">
				{btnsShown &&
					<div className="control-kit-background">
						<div className="control-kit-buttons">
							<BleedingControlBtn
								onClick={() => obj.parameters.onSelectionChanged(0)}
								text={'Pressure Dressing'}
								icon={'./assets/img/bandage.png'}
								disabled={disablePressureDressingButton}
							/>
							<BleedingControlBtn
								onClick={() => obj.parameters.onSelectionChanged(1)}
								text={'Tourniquet'}
								icon={'./assets/img/tourniquet.png'}
								disabled={disableTourniqueteButton}
							/>
							<BleedingControlBtn
								onClick={() => obj.parameters.onSelectionChanged(2)}
								text={'PPE'}
								icon={'./assets/img/ppe.png'}
								disabled={disablePPEButton}
							/>
						</div>
					</div>
				}
				<GeneralButtonWithImg
					text="Bleeding control kit"
					img={img}
					onClick={() => showBtns(!btnsShown)} />
			</div>
		</div>
	);
};

const BleedingControlBtn = (obj: any) => {
	return (
		<div className={`control-kit-btn-background ${obj.disabled ? 'disabled-container' : ''}`} style={obj.style}>
			<button tabIndex={0} onClick={obj.onClick} disabled={obj.disabled} className="control-kit-btn special-kit-btn">
				<div className="control-kit-img">
					<img src={obj.icon}></img>
				</div>
				<div>{obj.text}</div>
			</button>
		</div>
	);
};

export default BleedingControlKit;
